/**
 * Группы игроков и платные планы.
 *
 * Роль admin/moderator — это доступ в админку и модерацию. VIP и Premium —
 * отдельная подписка на месяц: косметика в чате и ускоренная игра. Админ
 * видит группу «Админ» и получает все премиум-возможности без оплаты.
 */
import { PAWS_SCALE } from "./money.js";
export const PLAN_DURATION_MS = 30 * 24 * 60 * 60 * 1000;
export const VIP_PRICE_RUB = 299;
export const PREMIUM_PRICE_RUB = 799;
/** 1 ₽ = 1 🐾: курс кассы ~80 лапок за доллар и ~80 ₽ за доллар. */
export const PLAN_PAWS_PER_RUB = PAWS_SCALE;
export const VIP_PRICE_PAWS = BigInt(VIP_PRICE_RUB) * PLAN_PAWS_PER_RUB;
export const PREMIUM_PRICE_PAWS = BigInt(PREMIUM_PRICE_RUB) * PLAN_PAWS_PER_RUB;
export const PREMIUM_MAX_MULTI = 5;
export const PREMIUM_MAX_CRASH_AUTO = 10;
export const NICK_COLORS = [
    { id: "gold", hex: "#ffd98a", label: "Золото" },
    { id: "amber", hex: "#fbbf24", label: "Янтарь" },
    { id: "orange", hex: "#fb923c", label: "Оранж" },
    { id: "rose", hex: "#fb7185", label: "Роза" },
    { id: "pink", hex: "#f472b6", label: "Розовый" },
    { id: "violet", hex: "#c084fc", label: "Фиолет" },
    { id: "indigo", hex: "#818cf8", label: "Индиго" },
    { id: "sky", hex: "#38bdf8", label: "Небо" },
    { id: "mint", hex: "#2dd4bf", label: "Мята" },
    { id: "lime", hex: "#a3e635", label: "Лайм" },
    { id: "white", hex: "#f8fafc", label: "Белый" },
    { id: "red", hex: "#f87171", label: "Алый" },
];
export const NICK_STICKERS = [
    { id: "crown", emoji: "👑" },
    { id: "star", emoji: "⭐" },
    { id: "sparkles", emoji: "✨" },
    { id: "fire", emoji: "🔥" },
    { id: "diamond", emoji: "💎" },
    { id: "heart", emoji: "❤️" },
    { id: "cat", emoji: "😺" },
    { id: "cool", emoji: "😎" },
    { id: "rocket", emoji: "🚀" },
    { id: "ghost", emoji: "👻" },
    { id: "moon", emoji: "🌙" },
    { id: "clover", emoji: "🍀" },
];
export function nickColorById(id) {
    if (!id)
        return undefined;
    return NICK_COLORS.find((item) => item.id === id);
}
export function nickStickerById(id) {
    if (!id)
        return undefined;
    return NICK_STICKERS.find((item) => item.id === id);
}
export function planPricePaws(plan) {
    return plan === "premium" ? PREMIUM_PRICE_PAWS : VIP_PRICE_PAWS;
}
export function planPriceRub(plan) {
    return plan === "premium" ? PREMIUM_PRICE_RUB : VIP_PRICE_RUB;
}
export function isPlanActive(plan, planUntil, now = Date.now()) {
    if (plan !== "vip" && plan !== "premium")
        return false;
    if (!planUntil)
        return false;
    const until = typeof planUntil === "string" ? Date.parse(planUntil) : planUntil.getTime();
    return Number.isFinite(until) && until > now;
}
export function displayGroup(input) {
    if (input.role === "admin")
        return "admin";
    if (isPlanActive(input.plan, input.planUntil, input.now))
        return input.plan;
    return "user";
}
export function groupLabel(group) {
    switch (group) {
        case "admin":
            return "Админ";
        case "premium":
            return "Premium";
        case "vip":
            return "VIP";
        default:
            return "Обычный";
    }
}
export function hasVipPerks(group) {
    return group === "vip" || group === "premium" || group === "admin";
}
export function hasPremiumPerks(group) {
    return group === "premium" || group === "admin";
}
export function maxMultiPlay(group) {
    return hasPremiumPerks(group) ? PREMIUM_MAX_MULTI : 1;
}
export function maxCrashAutoRounds(group) {
    return hasPremiumPerks(group) ? PREMIUM_MAX_CRASH_AUTO : 0;
}
export function formatPlanRemain(untilIso, now = Date.now()) {
    if (!untilIso)
        return "";
    const left = Date.parse(untilIso) - now;
    if (!Number.isFinite(left) || left <= 0)
        return "истёк";
    const days = Math.floor(left / 86_400_000);
    const hours = Math.floor((left % 86_400_000) / 3_600_000);
    if (days > 0)
        return `${days} дн ${hours} ч`;
    const minutes = Math.floor((left % 3_600_000) / 60_000);
    if (hours > 0)
        return `${hours} ч ${minutes} мин`;
    return `${Math.max(1, minutes)} мин`;
}
//# sourceMappingURL=plan.js.map